import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { CustomerGenerateReportsPage } from '@/features/customer/pages/generate-reports'

export const Route = createFileRoute('/_authenticated/customer/generate-reports')({
  validateSearch: z.object({
    campaign_id: z.string().optional(),
    start: z.string().optional(),
    end: z.string().optional(),
  }),
  component: CustomerGenerateReportsRoute,
})

function CustomerGenerateReportsRoute() {
  const search = Route.useSearch()
  return (
    <CustomerGenerateReportsPage
      initialCampaignId={search.campaign_id}
      initialStart={search.start}
      initialEnd={search.end}
    />
  )
}
